import Regions from './Regions';

export default Regions;



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Content/Regions/index.js